/**
 * Глобальный лог для дебаг-окна: действия пользователя и запросы/ответы API.
 */
const MAX_ENTRIES = 300;
let entries = [];
const listeners = new Set();

function push(entry) {
  const record = {
    id: Date.now() + Math.random(),
    ts: new Date().toISOString(),
    ...entry,
  };
  entries.push(record);
  if (entries.length > MAX_ENTRIES) entries = entries.slice(-MAX_ENTRIES);
  listeners.forEach((cb) => cb(record));
  return record;
}

function subscribe(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

function getEntries() {
  return [...entries];
}

function clear() {
  entries = [];
  listeners.forEach((cb) => cb(null));
}

export const debugLog = {
  push,
  subscribe,
  getEntries,
  clear,
};
